// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.support.enums.RentalManagerSupportHelpTopic

export enum RentalManagerSupportHelpTopic {
  AMENITY_QUESTION = 'AMENITY_QUESTION',
  BILLING = 'BILLING',
  BLOCKED_ACCOUNT = 'BLOCKED_ACCOUNT',
  EDIT = 'EDIT',
  EDIT_ADDRESS = 'EDIT_ADDRESS',
  FIX_MAP_PIN = 'FIX_MAP_PIN',
  GENERAL_QUESTION_ABOUT_MY_LISTING = 'GENERAL_QUESTION_ABOUT_MY_LISTING',
  GOOD_NEIGHBOR = 'GOOD_NEIGHBOR',
  LEADS = 'LEADS',
  LEASE_AGREEMENT = 'LEASE_AGREEMENT',
  MANAGE_USER_PERMISSIONS = 'MANAGE_USER_PERMISSIONS',
  MAPPING = 'MAPPING',
  MONTHLY_LISTING_REPORT = 'MONTHLY_LISTING_REPORT',
  PENDING = 'PENDING',
  PRICING = 'PRICING',
  PROPERTY_CONDITION_REPORTS = 'PROPERTY_CONDITION_REPORTS',
  RENTAL_APPLICATION = 'RENTAL_APPLICATION',
  /**
   * @deprecated
   */
  RENTAL_PROTECTION = 'RENTAL_PROTECTION',
  RENT_PAYMENTS = 'RENT_PAYMENTS',
  REPORT_SUSPICIOUS_ACTIVITY = 'REPORT_SUSPICIOUS_ACTIVITY',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SPONSORED_AD = 'SPONSORED_AD',
  TAX_VERIFICATION = 'TAX_VERIFICATION',
  TENANT_RENTERS_INSURANCE = 'TENANT_RENTERS_INSURANCE',
  TOURS_3D = 'TOURS_3D',
  TOUR_SCHEDULING = 'TOUR_SCHEDULING',
  UNABLE_TO_PUBLISH = 'UNABLE_TO_PUBLISH',
  UPDATE_OFF_MARKET = 'UPDATE_OFF_MARKET',
  VERIFY_PHONE = 'VERIFY_PHONE',
  ZESTIMATE = 'ZESTIMATE',
  ZILLOW_LEASE_CONNECT = 'ZILLOW_LEASE_CONNECT',
}

export const RentalManagerSupportHelpTopic_values = [
  RentalManagerSupportHelpTopic.AMENITY_QUESTION,
  RentalManagerSupportHelpTopic.BILLING,
  RentalManagerSupportHelpTopic.BLOCKED_ACCOUNT,
  RentalManagerSupportHelpTopic.EDIT,
  RentalManagerSupportHelpTopic.EDIT_ADDRESS,
  RentalManagerSupportHelpTopic.FIX_MAP_PIN,
  RentalManagerSupportHelpTopic.GENERAL_QUESTION_ABOUT_MY_LISTING,
  RentalManagerSupportHelpTopic.GOOD_NEIGHBOR,
  RentalManagerSupportHelpTopic.LEADS,
  RentalManagerSupportHelpTopic.LEASE_AGREEMENT,
  RentalManagerSupportHelpTopic.MANAGE_USER_PERMISSIONS,
  RentalManagerSupportHelpTopic.MAPPING,
  RentalManagerSupportHelpTopic.MONTHLY_LISTING_REPORT,
  RentalManagerSupportHelpTopic.PENDING,
  RentalManagerSupportHelpTopic.PRICING,
  RentalManagerSupportHelpTopic.PROPERTY_CONDITION_REPORTS,
  RentalManagerSupportHelpTopic.RENTAL_APPLICATION,
  RentalManagerSupportHelpTopic.RENTAL_PROTECTION,
  RentalManagerSupportHelpTopic.RENT_PAYMENTS,
  RentalManagerSupportHelpTopic.REPORT_SUSPICIOUS_ACTIVITY,
  RentalManagerSupportHelpTopic.RESET_PASSWORD,
  RentalManagerSupportHelpTopic.SPONSORED_AD,
  RentalManagerSupportHelpTopic.TAX_VERIFICATION,
  RentalManagerSupportHelpTopic.TENANT_RENTERS_INSURANCE,
  RentalManagerSupportHelpTopic.TOURS_3D,
  RentalManagerSupportHelpTopic.TOUR_SCHEDULING,
  RentalManagerSupportHelpTopic.UNABLE_TO_PUBLISH,
  RentalManagerSupportHelpTopic.UPDATE_OFF_MARKET,
  RentalManagerSupportHelpTopic.VERIFY_PHONE,
  RentalManagerSupportHelpTopic.ZESTIMATE,
  RentalManagerSupportHelpTopic.ZILLOW_LEASE_CONNECT,
] as const;
